// extracted by mini-css-extract-plugin
module.exports = {"position":"Toast_position__OfkrI","w-10":"Toast_w-10__0gK1R","w-90":"Toast_w-90__L52A4"};